import * as angular from "angular";
import {TagModel} from "../angular/models/tag.model";
import {TagType} from "../angular/types/tag.type";

export class TagsRequests {

  /* @ngInject */
  constructor(private TagsAPI, private $tags) {
  }

  createTag(tag: TagModel) {
    const api = this.TagsAPI.actions.createTag;
    return this.$$call(api, {}, tag, {});
  }

  editTag(tag: TagModel) {
    const api = this.TagsAPI.actions.editTag;
    return this.$$call(api, {}, tag, {id: tag.id});
  }

  getAllByTypes(types) {
    const api = this.TagsAPI.actions.getAllByTypes;
    return this.$$call(api, {type: types}, {}, {});
  }

  getTagsByName(names: string[], type: TagType) {
    const api = this.TagsAPI.actions.getTagsByName;
    return this.$$call(api, {type: type, names: names}, {}, {});
  }

  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$tags().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.tags')
  .service('tagsRequests', TagsRequests);
